export default __webpack_public_path__ + "static/fb-67c4d840c93a0566cc688a3d0eb68b35.png";